document.addEventListener('DOMContentLoaded', function () {
    // Handling the top collapsible button
    const collapsibleTrigger = document.querySelector('[data-collapsible-trigger]');
    const collapsibleContent = document.querySelector('[data-collapsible-content]');

    if (collapsibleTrigger && collapsibleContent) {
        collapsibleTrigger.addEventListener('click', function () {
            toggleContent(this, collapsibleContent);
        });

        collapsibleTrigger.addEventListener('keydown', handleKeydown);
    }

    // Handling the bottom collapse button
    const bottomTriggers = document.querySelectorAll('[data-bottom-collapse-trigger]');
    bottomTriggers.forEach((trigger) => {
        const targetId = trigger.getAttribute('aria-controls');
        const targetContent = document.getElementById(targetId);

        if (targetContent) {
            trigger.addEventListener('click', function () {
                toggleContent(this, targetContent);
            });

            trigger.addEventListener('keydown', handleKeydown);
        }
    });

    // Generic Folding Functions
    function toggleContent(trigger, content) {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

        // switch aria-expanded
        trigger.setAttribute('aria-expanded', !isExpanded);

        // Toggle content visibility
        if (isExpanded) {
            content.classList.add('collapsed');
            // Update button text
            const textSpan = trigger.querySelector('.toggle-text');
            if (textSpan) {
                textSpan.textContent = trigger.dataset.showComparisonText || textSpan.textContent;
            }
        } else {
            content.classList.remove('collapsed');
            // Update button text
            const textSpan = trigger.querySelector('.toggle-text');
            if (textSpan) {
                textSpan.textContent = trigger.dataset.hideComparisonText || textSpan.textContent;
            }

            // Smooth scrolling when expanding
            setTimeout(() => {
                const rect = content.getBoundingClientRect();
                const isInViewport = rect.top >= 0 && rect.bottom <= window.innerHeight;

                if (!isInViewport) {
                    trigger.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                    });
                }
            }, 300);
        }
    }

    // Keyboard Accessibility Processing
    function handleKeydown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.click();
        }
    }
});
